var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('img',{staticClass:"iconimg",attrs:{"src":require("../assets/img/fanh_ds_b.png"),"alt":""},on:{"click":_vm.gotop}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }